// Document review must finish its own reads before speculative navigation work.
// Named workflow routes such as upload/field-mapping keep their existing policy.
export function isDocumentDetailRoute(pathname: string): boolean {
  return /^\/projects\/[^/]+\/documents\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/?$/i.test(
    pathname,
  );
}
